const CategoryLayout = (props) => {
  const { headerContent, mainContent } = props;

  return (
    <div className="CategoryLayout">
      <div className="CategoryLayout-inner">
        {headerContent && <div className="CategoryLayout-header">{headerContent}</div>}
        {mainContent && <div className="CategoryLayout-main">{mainContent}</div>}
      </div>
    </div>
  );
};

export default CategoryLayout;
